import {
  CashbackTransactionDetails,
  money,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetCashbackTransactionDetails = gql`
  query GetCashbackDetailsById($id: ID!) {
    myPartnerOffers {
      cashback {
        transaction(id: $id) {
          id
          isCashbackTransaction
          description
          cashbackAmount {
            ...money
          }
          details {
            ...CashbackTransactionDetails
          }
        }
      }
    }
  }
  ${money}
  ${CashbackTransactionDetails}
`;

export default GetCashbackTransactionDetails;
